import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/leilei/Documents/wahala/valjratt/school-finder/components/AwardCategory.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/leilei/Documents/wahala/valjratt/school-finder/components/FAQ.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/leilei/Documents/wahala/valjratt/school-finder/components/ReportsSchoolSearch.tsx");
;
import(/* webpackMode: "eager" */ "/Users/leilei/Documents/wahala/valjratt/school-finder/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/Users/leilei/Documents/wahala/valjratt/school-finder/node_modules/next/dist/client/image-component.js");
